var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _g3, _path25, _g4, _path26, _g5, _path27, _g6, _path28, _g7, _path29, _g8, _path30, _path31, _path32, _path33, _path34, _path35, _g9, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g10, _path43, _g11, _path44, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutYou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 174,
    viewBox: "0 0 375 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12311_259024)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 174,
    fill: "#E6F1FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 131,
    width: 375,
    height: 43,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.105 75.617C367.938 74.5698 359.948 73.7266 350.109 73.7266C340.271 73.7266 332.28 74.5698 332.115 75.617C332.112 75.6289 332.105 75.6394 332.105 75.6499C332.105 76.7129 340.166 77.5746 350.109 77.5746C360.052 77.5746 368.113 76.7129 368.113 75.6499C368.113 75.6394 368.106 75.6289 368.105 75.617Z",
    fill: "#FCE4BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.393 147.038L363.105 146.962L352.592 85.8811H352.94V83.4434H350.469V62.3691H349.751V83.4434H347.28V85.8811H347.626L337.113 146.962L337.826 147.038L348.351 85.8811H349.751V152.797H350.469V85.8811H351.867L362.393 147.038Z",
    fill: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.217 58.9234C368.157 57.8591 360.074 57 350.109 57C340.276 57 332.274 57.8367 332.008 58.8813C332.003 58.8984 332 58.9168 332 58.9352C332 58.9523 332.003 58.9707 332.008 58.9892V75.6167H332.114C332.28 74.5695 340.271 73.7262 350.109 73.7262C359.948 73.7262 367.938 74.5695 368.105 75.6167H368.217V58.9471C368.218 58.9431 368.219 58.9392 368.219 58.9352C368.219 58.9313 368.218 58.9273 368.217 58.9234Z",
    fill: "#C97943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.87 147.638H172.729C167.871 147.638 163.895 143.664 163.895 138.805C163.895 133.947 167.871 129.972 172.729 129.972H291.87C296.729 129.972 300.705 133.947 300.705 138.805C300.705 143.664 296.729 147.638 291.87 147.638Z",
    fill: "#FFC10E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.222 113.381L279.312 100.362L279.508 114.368L298.643 138.039L300.222 113.381Z",
    fill: "#F9D987"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.202 112.359L289.925 105.889H284.963L296.262 114.246L306.202 112.359Z",
    fill: "#EF8D22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.263 114.245L294.582 150.844C294.582 152.031 295.553 153 296.738 153H299.288C300.474 153 301.446 152.031 301.446 150.844L307.332 114.245C307.332 113.061 306.361 112.089 305.177 112.089H298.417C297.232 112.089 296.263 113.061 296.263 114.245Z",
    fill: "#EF8D22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.107 113.381L185.019 100.362L184.822 114.368L165.686 138.039L164.107 113.381Z",
    fill: "#F9D987"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.127 112.359L174.404 105.889H179.366L168.069 114.246L158.127 112.359Z",
    fill: "#EF8D22"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.07 114.245L169.749 150.844C169.749 152.031 168.779 153 167.593 153H165.043C163.856 153 162.887 152.031 162.887 150.844L157 114.245C157 113.061 157.969 112.089 159.154 112.089H165.914C167.098 112.089 168.07 113.061 168.07 114.245Z",
    fill: "#EF8D22"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.43 79.9951H238.322C236.102 79.9951 234.107 80.9897 232.749 82.5506C231.735 80.9915 230.236 79.9951 228.57 79.9951H218.416H180.195C177.158 79.9951 174.674 83.2871 174.674 87.3121V132.425C174.674 136.448 177.158 139.74 180.195 139.74H228.57C230.236 139.74 231.735 138.746 232.749 137.185C234.107 138.746 236.102 139.74 238.322 139.74H282.43C286.5 139.74 289.827 136.411 289.827 132.343V87.3927C289.827 83.3247 286.5 79.9951 282.43 79.9951Z",
    fill: "#FFC10E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.718 121.319H246.255H226.186H170.037C167.826 121.319 166.02 123.127 166.02 125.339V133.107C166.02 135.319 167.826 137.127 170.037 137.127H226.186H246.255H294.718C296.938 137.127 298.755 135.31 298.755 133.089V125.355C298.755 123.136 296.938 121.319 294.718 121.319Z",
    fill: "#F9D987"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.797 118.862C289.369 118.733 278.676 117.38 264.217 117.38C245.171 117.38 234.847 119.301 232.772 119.729L232.468 119.693C232.468 119.693 222.068 117.258 200.623 117.258C186.163 117.258 174.719 118.76 174.719 118.76C174.719 118.76 169.755 120.65 167.348 122.324C167.223 122.412 201.435 122.62 201.435 122.62C201.435 122.62 214.352 122.537 220.201 123.025C226.05 123.512 232.873 125.462 232.873 125.462C232.873 125.462 235.874 124.602 236.109 124.548C238.546 124 241.715 123.39 244.639 123.146C250.487 122.659 263.404 122.741 263.404 122.741L297.494 122.437C296.845 121.44 290.467 119.064 289.797 118.862Z",
    fill: "#F7E7D7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M265 13.0288H199V59.8821H265V13.0288Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 15,
    width: 62,
    height: 43
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25 15.7849H201.75V57.126H262.25V15.7849Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.246 15.7849H201.746V57.126H262.246V15.7849Z",
    fill: "#89D0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.809 29.5652C217.466 29.5652 219.621 27.4058 219.621 24.7421C219.621 22.0783 217.466 19.9189 214.809 19.9189C212.151 19.9189 209.996 22.0783 209.996 24.7421C209.996 27.4058 212.151 29.5652 214.809 29.5652Z",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.971 14.407C253.733 14.407 258.403 19.0342 258.403 24.7423C258.403 29.7819 254.762 33.9791 249.945 34.8929C249.526 35.0131 249.084 35.0775 248.627 35.0775H235.394C232.76 35.0775 230.625 32.9378 230.625 30.2982C230.625 27.6587 232.76 25.5189 235.394 25.5189L237.569 25.5189C237.55 25.2625 237.54 25.0035 237.54 24.7423C237.54 19.0342 242.21 14.407 247.971 14.407Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.75 57.126H236.125L218.32 34.3585C217.383 33.1605 215.654 32.9505 214.459 33.8895C214.295 34.0181 214.146 34.1648 214.016 34.3269L201.75 49.5468V57.126Z",
    fill: "#686868"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.966 35.7664C212.886 35.7664 214.443 37.3088 214.443 39.2115C214.443 40.8913 213.229 42.2904 211.623 42.595C211.484 42.6351 211.337 42.6565 211.184 42.6565H206.773C205.895 42.6565 205.184 41.9433 205.184 41.0634C205.184 40.1836 205.895 39.4703 206.773 39.4703L207.498 39.4703C207.492 39.3849 207.489 39.2985 207.489 39.2115C207.489 37.3088 209.045 35.7664 210.966 35.7664Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.188 57.126H262.25V49.5468L242.428 29.0606C241.371 27.9678 239.63 27.941 238.54 29.0006C238.455 29.083 238.376 29.1709 238.302 29.2635L216.188 57.126Z",
    fill: "#9B9B9B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25 54.3699H201.75V57.1259H262.25V54.3699Z",
    fill: "#17B7FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.906 82.6087C115.201 82.9299 115.483 83.2622 115.777 83.5847C117.024 82.9614 118.47 82.7316 119.925 83.1099C123.144 83.946 125.082 87.2456 124.245 90.4645C123.408 93.6828 120.11 95.6216 116.891 94.7849C113.735 93.9645 111.852 90.7082 112.564 87.5517C112.157 87.4827 111.72 87.4249 111.328 87.3573C110.474 91.1588 112.782 94.9931 116.58 95.9802C120.458 96.9877 124.433 94.6528 125.441 90.7745C126.447 86.8969 124.113 82.922 120.235 81.9145C118.362 81.4272 116.476 81.7346 114.906 82.6087Z",
    fill: "#FFBF12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.652 32.5365L121.096 30.5734C120.495 29.4582 120.323 28.161 120.614 26.9276L120.779 26.2287C121.288 24.0725 120.367 21.8309 118.49 20.654L117.49 20.0274C116.481 19.3949 115.722 18.4347 115.338 17.3077L114.86 15.9008C114.146 13.8024 112.177 12.3916 109.961 12.3903L107.435 12.3897C106.14 12.389 104.894 11.9036 103.939 11.0288L103.719 10.8265C102.085 9.32971 99.6787 9.0381 97.7353 10.1021L97.3925 10.2899C95.8608 11.128 94.0094 11.1378 92.4686 10.3149L91.1497 9.61082C89.1951 8.56653 86.792 8.88244 85.1743 10.3963L84.7592 10.7851C83.4003 12.056 81.4641 12.5 79.6875 11.9483C77.5714 11.2915 75.2707 12.0547 73.9676 13.8464L73.4153 14.605C72.3112 16.1215 70.4742 16.9221 68.6116 16.6982L67.1023 16.5169C64.902 16.2522 62.778 17.4173 61.8184 19.4153L61.2057 20.6908C60.407 22.3524 58.7861 23.4643 56.9484 23.6102C54.0881 23.8367 51.6908 25.8583 50.9835 28.6385L50.7543 29.5416C50.066 32.2462 48.0194 34.3972 45.3522 35.2175L45.0061 35.3245C42.888 35.9761 41.4201 37.9037 41.3544 40.1191L41.2749 42.7922C41.2191 44.6824 40.1374 46.392 38.4527 47.2511L37.0098 47.986C35.7849 48.6113 35.0933 49.9465 35.2896 51.3074L35.5819 53.3303C35.7665 54.6051 35.1708 55.8674 34.0693 56.536L33.4401 56.9176C32.2645 57.6315 31.6734 59.0141 31.9696 60.3565L32.7091 63.7035C32.9843 64.952 32.4931 66.2459 31.4573 66.9966L29.7799 68.2136C28.666 69.0208 28.1911 70.4473 28.5964 71.7616L29.9007 75.9886C30.2725 77.1925 29.9053 78.5034 28.9622 79.3395L26.6871 81.3565C25.6586 82.2688 25.3243 83.7347 25.8563 85.003L27.4949 88.9089C27.9718 90.0464 27.7557 91.356 26.9393 92.2801L24.8054 94.6918C23.8951 95.7223 23.7408 97.2178 24.4225 98.4125L26.8296 102.63C27.4227 103.669 27.3892 104.951 26.7436 105.958L24.6925 109.154C23.9503 110.311 24.0265 111.812 24.8823 112.889L27.0654 115.632C27.6499 116.368 27.8838 117.321 27.7051 118.243L27.007 121.847C26.7456 123.198 27.3721 124.564 28.5655 125.247L30.3224 126.252C31.1506 126.726 31.7259 127.544 31.8908 128.484L32.4629 131.737C32.7006 133.091 33.7745 134.144 35.1333 134.355L39.2021 134.987C40.0454 135.119 40.8014 135.579 41.3038 136.268L43.4535 139.211C44.2639 140.322 45.6924 140.793 47.0047 140.384L51.771 138.897C52.2136 138.758 52.6813 138.717 53.141 138.777L57.8094 139.383C60.1896 137.281 63.4308 136.253 66.6379 137.458C73.5177 140.042 81.1443 138.767 88.2395 137.749C88.6986 137.684 89.1564 137.646 89.6115 137.622C89.9511 137.299 90.357 137.04 90.8253 136.888L92.1783 136.446C93.7598 135.931 94.8376 134.466 94.8599 132.802L94.9105 128.944C94.9354 127.077 96.2845 125.491 98.1228 125.168C100.269 124.791 101.935 123.09 102.27 120.939L102.55 119.134C102.881 117.003 104.442 115.27 106.528 114.72C108.671 114.154 110.215 112.288 110.371 110.078L110.631 106.384C110.714 105.206 111.197 104.092 112 103.226L112.511 102.676C114.018 101.051 114.324 98.6477 113.273 96.697L112.056 94.441C111.455 93.3257 111.282 92.0286 111.574 90.7951L111.739 90.097C112.248 87.9401 111.327 85.6985 109.449 84.5216L108.449 83.895C107.441 83.2625 106.681 82.3023 106.298 81.1752L105.819 79.7684C105.106 77.67 103.137 76.2592 100.92 76.2579L98.3941 76.2572C98.1458 76.2572 97.9034 76.2231 97.6604 76.1883C97.6098 74.7637 98.4978 73.4653 99.8652 73.02L101.219 72.5786C102.8 72.063 103.879 70.5984 103.901 68.9348L103.95 65.0762C103.975 63.2096 105.325 61.6235 107.164 61.2997C109.309 60.9227 110.976 59.2229 111.31 57.0706L111.591 55.2658C111.922 53.1352 113.483 51.4026 115.568 50.8522C117.711 50.2867 119.707 52.6163 121.314 47.7975C122.92 42.978 119.201 40.5276 121.552 38.8075C123.902 37.088 123.704 34.4871 122.652 32.5365Z",
    fill: "#211F1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4941 174.616L128 174.592C126.726 155.315 120.988 140.013 110.467 132.362C106.654 129.589 92.211 126.021 94.2149 115.336C97.0266 100.348 103.143 109.992 109.511 105.903C114.398 102.763 118.889 95.2437 120.114 89.5664C121.338 83.8885 123.823 59.1554 119.307 46.3291C115.509 35.5447 103.533 28.6833 87.4382 33.4239C76.8088 36.5548 67.7853 45.7741 67.6014 58.8749C67.5252 64.3072 68.7783 69.059 71.6603 73.0267C76.8055 80.1094 79.945 89.8561 62.2545 121.803C55.4305 134.124 32.6822 123.755 29.4941 174.616Z",
    fill: "#C98A57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.655 143.028C142.007 141.426 105.718 123.932 105.718 123.932C105.718 123.932 103.879 139.637 91.9974 139.637C73.7677 139.637 64.5517 126.255 57.463 118.724C51.3451 118.688 45.2278 118.633 -1.9082 118.732V189.869H143.655V143.028Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 57.6376L126.521 59.1003C123.198 55.5103 114.291 54.5797 111.1 60.961C107.429 68.3031 110.967 73.4582 116.152 78.3769C119.181 81.2503 113.227 86.8855 108.841 85.2902C113.392 92.8301 110.169 103.105 104.188 110.151C109.011 110.819 117.907 109.379 121.942 106.609C125.977 103.838 129.104 99.8392 131.339 95.4408C137.802 82.7228 136.365 69.1399 127.984 57.6376Z",
    fill: "black",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4316 90.5398H115.138C115.138 90.5398 114.16 95.7579 108.475 96.2374C101.2 96.8508 97.4316 90.5398 97.4316 90.5398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5953 76.1248C89.1951 31.2849 129.493 45.4392 135.981 58.7824C138.472 48.3041 128.483 33.3931 120.986 26.9849C107.692 15.6186 86.1463 7.91126 70.2055 18.1531C58.5706 25.6273 54.9682 34.9037 54.9609 48.268C54.9583 52.2139 58.9286 77.3497 71.5953 76.1248Z",
    fill: "#FFC224"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8084 82.5475C75.1033 82.8686 75.3857 83.2016 75.6793 83.5234C76.9265 82.9008 78.3727 82.6703 79.8275 83.0486C83.0458 83.8847 84.9839 87.1844 84.1478 90.4032C83.3104 93.6215 80.0127 95.5603 76.7925 94.7236C73.638 93.9032 71.755 90.6469 72.4669 87.4904C72.0584 87.4215 71.6223 87.3637 71.2302 87.296C70.3757 91.0975 72.6843 94.9318 76.4825 95.9189C80.3595 96.9264 84.3357 94.5916 85.3425 90.7139C86.35 86.8356 84.0158 82.8608 80.1375 81.8532C78.2644 81.3659 76.3787 81.6733 74.8084 82.5475Z",
    fill: "#FFBF12"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2526 120.303C76.0564 130.583 77.7128 175.218 78.4313 181.736C85.8615 183.02 100.238 182.915 100.995 180.489C102.71 174.991 103.589 127.273 100.152 120.615C104.286 119.632 120.722 120.981 124.972 121.58C133.056 122.721 149.194 218.02 142.271 217.283C142.247 217.281 142.223 217.278 142.2 217.276C120.831 215.042 22.7558 209.425 19.2111 208.431C18.7513 202.561 20.482 129.911 22.7722 119.309C24.0851 113.232 63.1703 119.423 59.2526 120.303Z",
    fill: "#0071CE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 99,
    height: 144
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4382 33.4246C76.8095 36.5541 67.784 45.7741 67.6014 58.8749C67.5252 64.3072 68.7777 69.0596 71.6616 73.026C76.8055 80.1094 79.9443 89.856 62.2538 121.803C55.4305 134.123 32.6822 123.755 29.4941 174.617L127.734 174.593V171.284C126.045 153.569 120.379 139.571 110.468 132.362C106.654 129.589 92.211 126.02 94.2155 115.337C96.021 105.713 99.1881 106.244 102.909 106.775C104.983 107.072 107.231 107.367 109.511 105.903C114.398 102.764 118.89 95.2436 120.114 89.5657C121.338 83.8885 123.823 59.156 119.307 46.329C116.346 37.9222 108.414 31.8982 97.4351 31.8982C94.3311 31.8982 90.9855 32.379 87.4382 33.4246Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5405 98.4985L78.2821 95.6612C77.6607 94.2589 77.5747 92.6774 78.041 91.2161L78.3044 90.3879C80.1828 81.8109 71.6308 72.9831 71.6308 72.9831C71.6308 72.9831 69.2401 72.9102 66.588 72.6816C63.1314 74.1955 59.789 75.9163 56.9189 78.3825C51.2823 83.2256 46.1535 89.0349 43.2335 95.9331C39.2724 105.287 38.9578 115.486 41.4404 125.054C42.9491 126.072 44.5411 126.974 46.2199 127.719C49.5268 129.189 45.7844 128.812 49.1563 130.326C58.1267 135.902 62.8549 131.175 63.9964 126.735L64.5034 124.582C65.103 122.041 67.1496 120.095 69.7169 119.625C72.3566 119.142 74.3959 117.034 74.7899 114.38L75.4487 109.946C75.6576 108.531 76.3452 107.231 77.3954 106.261L78.0633 105.644C80.0344 103.824 80.6281 100.951 79.5405 98.4985Z",
    fill: "#211F1F"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3063 69.7859C96.3063 71.7477 94.7155 73.3385 92.7537 73.3385C90.7912 73.3385 89.2012 71.7477 89.2012 69.7859C89.2012 67.8241 90.7912 66.2334 92.7537 66.2334C94.7155 66.2334 96.3063 67.8241 96.3063 69.7859Z",
    fill: "#211F1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.146 69.7859C119.146 71.7477 117.555 73.3385 115.594 73.3385C113.631 73.3385 112.041 71.7477 112.041 69.7859C112.041 67.8241 113.631 66.2334 115.594 66.2334C117.555 66.2334 119.146 67.8241 119.146 69.7859Z",
    fill: "#211F1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7549 98.3223C73.7402 98.3223 78.5918 93.4706 78.5918 87.4854C78.5918 81.5001 73.7402 76.6484 67.7549 76.6484C61.7696 76.6484 56.918 81.5001 56.918 87.4854C56.918 93.4706 61.7696 98.3223 67.7549 98.3223Z",
    fill: "#211F1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5744 120.653C67.0052 120.653 74.6508 112.862 74.6508 103.248C74.6508 93.6349 67.0052 85.8435 57.5744 85.8435C48.1437 85.8435 40.498 93.6349 40.498 103.248C40.498 112.862 48.1437 120.653 57.5744 120.653Z",
    fill: "#211F1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3505 130.505C57.6053 130.505 63.4862 125.946 63.4862 120.324C63.4862 114.703 57.6053 110.144 50.3505 110.144C43.0957 110.144 37.2148 114.703 37.2148 120.324C37.2148 125.946 43.0957 130.505 50.3505 130.505Z",
    fill: "#211F1F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 66,
    width: 63,
    height: 56
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M187.14 66.1458V85.2413C186.762 92.1929 186.762 99.1188 187.14 106.019L187.184 106.807C187.56 113.179 188.186 117.964 189.06 121.161L189.114 121.355H218.731L219.601 121.359L220.785 121.371L221.508 121.375C225.468 121.377 227.16 121.105 229.051 119.897C231.748 118.174 233.003 114.936 233.045 109.747L233.046 109.482V84.2519C233.046 80.0404 234.659 78.3154 238.475 78.3154C242.341 78.3154 244.137 80.1154 244.403 84.3753C244.471 85.4661 245.408 86.295 246.496 86.2268C247.585 86.1587 248.412 85.2192 248.344 84.1285C247.951 77.8347 244.482 74.3578 238.475 74.3578C232.484 74.3578 229.168 77.8345 229.098 84.0504L229.097 84.2519V109.482C229.097 113.611 228.32 115.671 226.928 116.56L226.796 116.641C225.875 117.183 224.732 117.38 222.282 117.411C223.484 106.798 221.149 98.548 215.276 92.6618C212.367 89.7465 208.911 87.6365 204.91 86.3319L204.91 66.1458L200.467 71.0928H191.582L187.14 66.1458Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.14 66.1458V85.2413C186.762 92.1929 186.762 99.1188 187.14 106.019L187.184 106.807C187.56 113.179 188.186 117.964 189.06 121.161L189.114 121.355H218.731L219.601 121.359L220.785 121.371L221.508 121.375C225.468 121.377 227.16 121.105 229.051 119.897C231.748 118.174 233.003 114.936 233.045 109.747L233.046 109.482V84.2519C233.046 80.0404 234.659 78.3154 238.475 78.3154C242.341 78.3154 244.137 80.1154 244.403 84.3753C244.471 85.4661 245.408 86.295 246.496 86.2268C247.585 86.1587 248.412 85.2192 248.344 84.1285C247.951 77.8347 244.482 74.3578 238.475 74.3578C232.484 74.3578 229.168 77.8345 229.098 84.0504L229.097 84.2519V109.482C229.097 113.611 228.32 115.671 226.928 116.56L226.796 116.641C225.875 117.183 224.732 117.38 222.282 117.411C223.484 106.798 221.149 98.548 215.276 92.6618C212.367 89.7465 208.911 87.6365 204.91 86.3319L204.91 66.1458L200.467 71.0928H191.582L187.14 66.1458Z",
    fill: "#DFDDD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.909 85.2412V102.556L203.922 113.934L204.909 117.892L213.301 125.312H238.968V100.082L204.909 85.2412Z",
    fill: "#938456"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.725 77.326C199.043 77.326 198.491 76.7723 198.491 76.0893C198.491 75.4063 199.043 74.8525 199.725 74.8525C200.406 74.8525 200.959 75.4063 200.959 76.0893C200.959 76.7723 200.406 77.326 199.725 77.326Z",
    fill: "#031D43"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.321 77.326C191.639 77.326 191.087 76.7723 191.087 76.0893C191.087 75.4063 191.639 74.8525 192.321 74.8525C193.002 74.8525 193.555 75.4063 193.555 76.0893C193.555 76.7723 193.002 77.326 192.321 77.326Z",
    fill: "#031D43"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M197.53 81.1729L196.049 79.6888L194.568 81.1729",
    stroke: "#979797",
    strokeWidth: 1.12882
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.504 78.3154H194.542L196.023 79.7995L197.504 78.3154Z",
    fill: "#F13C12"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.022 106.711C195.069 106.711 194.297 107.486 194.297 108.441C194.297 108.518 194.302 108.596 194.312 108.672L196.022 121.355L197.732 108.672C197.86 107.726 197.198 106.855 196.253 106.727C196.177 106.717 196.1 106.711 196.022 106.711Z",
    fill: "#A38C60"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.363 116.408C206.553 115.748 205.072 114.923 203.92 113.934L202.933 121.355H204.907L208.363 117.892H213.299C211.818 117.562 210.173 117.067 208.363 116.408Z",
    fill: "#A38C60"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 117,
    width: 8,
    height: 5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M204.908 121.354C204.908 119.442 206.455 117.892 208.363 117.892C210.271 117.892 211.818 119.442 211.818 121.354H204.908Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.908 121.354C204.908 119.442 206.455 117.892 208.363 117.892C210.271 117.892 211.818 119.442 211.818 121.354H204.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.023 119.128C208.736 119.128 208.498 119.22 208.457 119.339L208.451 119.376V122.344C208.451 122.481 208.707 122.591 209.023 122.591C209.311 122.591 209.549 122.5 209.589 122.381L209.596 122.344V119.376C209.596 119.239 209.339 119.128 209.023 119.128Z",
    fill: "#031D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.049 119.128C206.761 119.128 206.523 119.22 206.482 119.339L206.476 119.376V122.344C206.476 122.481 206.732 122.591 207.049 122.591C207.336 122.591 207.574 122.5 207.615 122.381L207.621 122.344V119.376C207.621 119.239 207.365 119.128 207.049 119.128Z",
    fill: "#031D43"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 117,
    width: 7,
    height: 5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M196.023 121.354C196.023 119.442 197.57 117.892 199.478 117.892C201.387 117.892 202.934 119.442 202.934 121.354H196.023Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.023 121.354C196.023 119.442 197.57 117.892 199.478 117.892C201.387 117.892 202.934 119.442 202.934 121.354H196.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.14 119.128C199.853 119.128 199.615 119.22 199.574 119.339L199.568 119.376V122.344C199.568 122.481 199.824 122.591 200.14 122.591C200.428 122.591 200.666 122.5 200.707 122.381L200.713 122.344V119.376C200.713 119.239 200.457 119.128 200.14 119.128Z",
    fill: "#031D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.162 119.128C197.874 119.128 197.636 119.22 197.595 119.339L197.589 119.376V122.344C197.589 122.481 197.846 122.591 198.162 122.591C198.449 122.591 198.687 122.5 198.728 122.381L198.734 122.344V119.376C198.734 119.239 198.478 119.128 198.162 119.128Z",
    fill: "#031D43"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_12311_259024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 117,
    width: 8,
    height: 5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M189.115 121.354C189.115 119.442 190.662 117.892 192.57 117.892C194.478 117.892 196.025 119.442 196.025 121.354H189.115Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_12311_259024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.115 121.354C189.115 119.442 190.662 117.892 192.57 117.892C194.478 117.892 196.025 119.442 196.025 121.354H189.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.232 119.128C192.945 119.128 192.707 119.22 192.666 119.339L192.66 119.376V122.344C192.66 122.481 192.916 122.591 193.232 122.591C193.52 122.591 193.758 122.5 193.798 122.381L193.805 122.344V119.376C193.805 119.239 193.548 119.128 193.232 119.128Z",
    fill: "#031D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.256 119.128C190.968 119.128 190.73 119.22 190.689 119.339L190.683 119.376V122.344C190.683 122.481 190.939 122.591 191.256 122.591C191.543 122.591 191.781 122.5 191.822 122.381L191.828 122.344V119.376C191.828 119.239 191.572 119.128 191.256 119.128Z",
    fill: "#031D43"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12311_259024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 174,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutYou);
export default __webpack_public_path__ + "static/media/aboutYou.96ede2571d93c7a83260cfc458c6420b.svg";
export { ForwardRef as ReactComponent };